import { render, staticRenderFns } from "./WalletItem.vue?vue&type=template&id=052e5ab3&"
import script from "./WalletItem.vue?vue&type=script&lang=js&"
export * from "./WalletItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports